import { useQuery, useQueryClient, QueryClient } from 'react-query'
import { QueryKey } from 'config/constants/queryKey'
import { useVvsMinerMoleContract } from 'hooks/useContract'
import { queryKeyBalanceOfUser, queryBalanceOfUser } from 'hooks/vvs-miner-mole/useMoleContract'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { VvsMinerMole } from '../../../../types/ethers-contracts'

type TokensOfUserRes = {
  data: { tokenIds: string[]; balanceOfUser: number }
  isLoading: boolean
  error?: any
}

const EMPTY_TOKEN_BALANCE: TokensOfUserRes['data'] = {
  tokenIds: [],
  balanceOfUser: 0,
}

export const queryKeyTokensOfUser = (account: string) => [QueryKey.VVS_MOLE_TOKENS_OF_USER, account]
export const queryTokensOfUser = async (queryClient: QueryClient, contract: VvsMinerMole, account: string) => {
  const balanceOfUser = await queryClient.fetchQuery(queryKeyBalanceOfUser(account), () =>
    queryBalanceOfUser(contract, account),
  )
  if (balanceOfUser <= 0) return EMPTY_TOKEN_BALANCE
  const tokenIds = await Promise.all(
    Array(balanceOfUser)
      .fill(null)
      .map(async (_, index) => {
        const res = await contract.tokenOfOwnerByIndex(account, index)
        return res.toString()
      }),
  )

  return {
    tokenIds,
    balanceOfUser,
  }
}

export const useTokensOfUser = (): TokensOfUserRes => {
  const { account } = useActiveWeb3React()
  const queryClient = useQueryClient()
  const vvsMinerMoleContract = useVvsMinerMoleContract()

  return useQuery(queryKeyTokensOfUser(account), () => queryTokensOfUser(queryClient, vvsMinerMoleContract, account))
}
